/**
 * Versie en build-stempel van deze web-app. Het nummer komt uit
 * `@ae/api-client` (één nummer voor alle onderdelen), de stempel uit
 * `scripts/build-stamp.mjs` via Vite's `define`.
 */
import { APP_VERSION, type ServerVersion, versionLabel } from "@ae/api-client";

declare const __BUILD_COMMIT__: string;
declare const __BUILD_DATE__: string;

export const BUILD = {
  commit: typeof __BUILD_COMMIT__ === "string" ? __BUILD_COMMIT__ : "dev",
  date: typeof __BUILD_DATE__ === "string" ? __BUILD_DATE__ : "dev",
};

export const WEB_VERSION_LABEL = versionLabel(APP_VERSION, BUILD);

/** De versie van de server; `null` als die niet op te halen is. */
export async function fetchServerVersion(): Promise<ServerVersion | null> {
  try {
    const res = await fetch("/api/v1/version");
    return res.ok ? ((await res.json()) as ServerVersion) : null;
  } catch {
    return null;
  }
}
